module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-700italic.5eca10b5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-700italic.woff2
// module id = 491
// module chunks = 0